namespace GeniuzPOS.ReportMasterData {
    export class Report_1402Columns {
        static columnsKey = 'ReportMasterData.Report_1402';
    }
}
